import React, { useState, useEffect, useCallback, useRef } from "react";
import emailjs from "emailjs-com";
import '../Css/PhantomTest.css'; // Import your CSS file here
import phantompic from "../Images/home/PanTum-Logo.png"
import { Mail, Phone, MapPin, User, Send, CheckCircle, Star, Shield, Users, Award } from 'lucide-react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import { Helmet } from "react-helmet";
import HospitalTreatmentsShowcase from "./HospitalTreatmentsShowcase";
import ServiceCall from "../ServiceCall";
const PhantomTest = () => {
 const [formData, setFormData] = useState({
  name: '',
  email: '',
  phone: '',
  address: '',
  coupon: '', // <-- Add coupon to initial state
});
  const formRef = useRef(null);
const handleLearnMoreClick = () => {
  const section = document.getElementById("test");
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
const videoPlayerRef = useRef(null);
const [ytReady, setYtReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const mode = process.env.REACT_APP_MODE; // e.g., 'dev', 'prod'

  const payload = {
    email: formData.email,
    country_code: '+91', // 🔧 Replace with dynamic code if available
    phone: formData.phone,
    name: formData.name,
    address: formData.address,
    source_url: 'https://rxone.app/shop/book-pantum-detect',
    request_type: 'book-pantum-detect',
    coupon_code: formData.coupon , // 🔧 Optional: add value if needed
  };

  try {
    await ServiceCall.post(`/rxopd/rxone/patient/treatment/advice/contactus/form/${mode}`, payload);

    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', address: '' });
      setSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error('API submission error:', error);
    alert('Failed to submit the form. Please try again.');
  } finally {
    setLoading(false);
  }
};


      const [isMobile, setIsMobile] = useState(window.innerWidth < 640); // <-- Move here
const videoRef = useRef(null);
  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPlayVideo(true);
          observer.disconnect(); // optional: run once
        }
      },
      {
        threshold: 0.5, // video visible by 50%
      }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const testimonials = [
  {
    name: "Ravi Mehta",
    role: "",
    testimonial:
      "Peace of mind is priceless. I took the PanTum Detect test as part of my annual health checkup. The process was smooth, just a simple blood draw. Thankfully, it came back clear—but knowing I had such a comprehensive screening done feels incredibly reassuring.",
    rating: 4,
  },
  {
    name: "Anita Desai",
    role: "",
    testimonial:
      "I was a bit skeptical at first, but after reading up on its accuracy, I went ahead. The test flagged something abnormal, which led to a follow-up MRI that revealed a very early-stage thyroid nodule. Grateful for the early alert, though I wish the report had more clarity without needing specialist interpretation.",
    rating: 5,
  },
  {
    name: "Dr. Sneha Ramesh",
    role: "Oncologist",
    testimonial:
      "As an oncologist, I’ve started recommending PanTum Detect to high-risk patients. The science behind it is solid, especially as an early warning tool. It should never replace imaging or biopsy, but as a frontline screen—it’s revolutionary.",
    rating: 4,
  },
  {
    name: "Elizabeth George",
    role: "",
    testimonial:
      "This test caught my dad’s early-stage lung tumor when he had absolutely no symptoms. Surgery was successful and recovery is going well. We’re extremely thankful. One star off because we had to wait 10 days for the results.",
    rating: 5,
  },
  {
    name: "Kavita Nair",
    role: "",
    testimonial:
      "My husband has a family history of cancer, so we opted for this test as a preventive measure. It gave us confidence and started a conversation about proactive health. The staff at the clinic were professional and explained everything clearly.",
    rating: 4,
  },
  {
    name: "Rahul Chopra",
    role: "",
    testimonial:
      "Got this test done during a corporate health camp. It was painless and surprisingly quick. The report was detailed and highlighted ‘no tumor activity.’ Definitely something every working professional should consider annually.",
    rating: 5,
  },
  {
    name: "Dr. Alok Menon",
    role: "",
    testimonial:
      "The PanTum Detect test is a promising breakthrough, especially for high-risk, asymptomatic patients. I’ve integrated it into my private practice and seen it help catch early-stage tumors that would otherwise go unnoticed. A great addition to India’s screening arsenal.",
    rating: 3,
  },
  {
    name: "Meera Vishwanathan",
    role: "",
    testimonial:
      "I appreciate the intent, but the follow-up process needs streamlining. After my positive result, it took multiple referrals to get a PET-CT appointment. Thankfully, it was a benign lesion—but I wish the care pathway was more organized.",
    rating: 2,
  },
  {
    name: "Arvind Patel",
    role: "",
    testimonial:
      "The test might be accurate, but it’s not for everyone. My parents were very stressed by the terminology in the report. They thought they had cancer until we met the doctor. Needs simpler communication for senior citizens.",
    rating: 4,
  },
  {
    name: "Nisha Thomas",
    role: "",
    testimonial:
      "I’m a caregiver for my elderly aunt, and this test helped us identify a uterine growth that could have gone undetected for months. The cost is a concern, but it’s far less than late-stage cancer treatment. Worth it if you can afford it.",
    rating: 5,
  },
  {
    name: "Harpreet Singh",
    role: "",
    testimonial:
      "This is the kind of innovation India needs. I did the test along with my wife. We were both negative, but the fact that this can detect over 20 types of cancer through blood is nothing short of amazing. Would recommend it to everyone above 40.",
    rating: 5,
  },
];
const handleScheduleClick = () => {
  if (formRef.current) {
    formRef.current.scrollIntoView({ behavior: "smooth" });
  }
};
useEffect(() => {
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
    window.onYouTubeIframeAPIReady = () => setYtReady(true);
  } else {
    setYtReady(true);
  }
}, []);
const [factsVisible, setFactsVisible] = useState(false);
const aboutRef = useRef(null);
const [factNumbers, setFactNumbers] = useState({
  oneInTen: 0,
  ninety: 0,
  lakh: 0,
  seventyFive: 0,
});
useEffect(() => {
  const observer = new window.IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setFactsVisible(true);
        observer.disconnect();
      }
    },
    { threshold: 0.4 }
  );
  if (aboutRef.current) observer.observe(aboutRef.current);
  return () => observer.disconnect();
}, []);
useEffect(() => {
  if (ytReady && playVideo && videoRef.current && !videoPlayerRef.current) {
    videoPlayerRef.current = new window.YT.Player('pantum-video', {
      videoId: 'nT1SbbTn_jQ',
      playerVars: {
        autoplay: 1,
        mute: 1,
        controls: 1,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
      },
      events: {
        onStateChange: (event) => {
          // 0 = ended
          if (event.data === 0) {
            event.target.seekTo(0);
            event.target.playVideo();
          }
        }
      }
    });
  }
  // Cleanup
  return () => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.destroy();
      videoPlayerRef.current = null;
    }
  };
}, [ytReady, playVideo]);
useEffect(() => {
  if (!factsVisible) return;

  // Animate numbers
  let start = null;
  const duration = 1200; // ms

  const animate = (timestamp) => {
    if (!start) start = timestamp;
    const progress = Math.min((timestamp - start) / duration, 1);

    setFactNumbers({
      oneInTen: Math.floor(progress * 1) || 1,
      ninety: Math.floor(progress * 90),
      lakh: Math.floor(progress * 1390000),
      seventyFive: Math.floor(progress * 75),
    });

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      setFactNumbers({
        oneInTen: 1,
        ninety: 90,
        lakh: 1390000,
        seventyFive: 75,
      });
    }
  };

  requestAnimationFrame(animate);
}, [factsVisible]);
useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 640);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
  {
    question: "What is PanTum® Detect?",
    answer:
      "PanTum® Detect is a multi-tumor screening blood test that measures levels of two enzyme biomarkers present within your immune cells (macrophages). If the enzyme biomarkers levels are raised, the test is positive."
  },
  {
    question: "What does the PanTum® Detect blood test detect?",
    answer:
      "PanTum® Detect detects the presence of two enzyme biomarkers in whole human blood, which are increasingly formed in all solid tumors – even in the early, asymptomatic phase. These biomarkers are Transketolase-like-1 (TKTL1) and DNaseX (Apo10)."
  },
  {
    question: "What is TKTL1 and what does it indicate?",
    answer:
      "TKTL1 provides an indication of switch towards invasive growth. It regulates anaerobic glucose metabolism (Warburg effect), which is fermentation of glucose using the Pentose Phosphate Pathway. This leads to lactic acid formation and collagen matrix breakdown, resulting in metastasis."
  },
  {
    question: "What is DNaseX (Apo10) and what does it indicate?",
    answer:
      "DNaseX (Apo10) indicates tumor proliferation. Elevated levels suggest disruption in programmed cell death (Apoptosis)."
  },
  {
    question: "Does the test show the location, spread or type of cancer?",
    answer:
      "No, the test does not determine the type, spread, or location of cancer. A positive result indicates the presence of a tumor due to raised biomarker levels. Confirmatory diagnosis requires Imaging (PET/CT, MRI) and Pathology (Tumor markers, Histopathology / Cytology). The 'Cancer-Scan' program combines PanTum® Detect with these techniques for integrated early cancer detection."
  },
  {
    question: "My PanTum® Detect test is positive – what happens next?",
    answer:
      "If your test is positive, schedule an appointment with your doctor. You will be clinically assessed and referred to an Oncologist for confirmatory diagnosis using Imaging and Pathology."
  },
  {
    question: "My PanTum® Detect test is negative – what happens next?",
    answer:
      "This is good news! No immediate further testing is needed. Continue a healthy lifestyle. Your doctor may recommend retesting after 3 to 12 months, based on your PanTum® Detect negative score. Routine cancer screenings should continue as advised."
  },
  {
    question: "How accurate is PanTum® Detect?",
    answer:
      "PanTum® Detect has a CE IVD certification with 97.5% sensitivity (true positives) and 99% specificity (true negatives). Statistically, 2.5 in 100 candidates with the disease may receive a false negative, and 1 in 100 candidates may receive a false positive."
  },
  {
    question: "Who should consider taking the PanTum® Detect test?",
    answer:
      "Recommended for proactive individuals, people over 50, those with family history of cancer, or anyone seeking comprehensive early cancer screening."
  },
  {
    question: "Who is excluded from undergoing PanTum® Detect blood test?",
    answer:
      "Exclusion criteria:\n• Individuals under 18 years\n• Those on active cancer treatment\n• After contrast imaging – wait 1 week\n• Post-infection (e.g. Covid, Typhoid) – wait 2 weeks\n• Post-vaccination – wait 4 weeks\n• On medications like corticosteroids, immunosuppressants, Amygdalin (B17), or GMCSF – wait 8 weeks after stopping\n• Post-surgery, trauma, or febrile illness – wait 8 weeks\n• Individuals in remission for at least 1 year can undergo the test"
  },
  {
    question: "What are the benefits and limitations of PanTum® Detect and Cancer-Scan?",
    answer:
      "**Benefits:**\n• Simple blood test\n• High sensitivity (97.5%) and specificity (99%)\n• Suitable for annual screening\n• Imaging required only for positives\n• Detects cancer early\n\n**Limitations:**\n• Not for individuals with compromised immune systems\n• No test is 100% accurate\n• 1 in 100 may get a false positive\n• 2.5 in 100 may get a false negative\n• False results can cause psychological stress"
  },
  {
    question: "How is the test performed?",
    answer:
      "The test only requires a simple blood draw. The sample is analyzed in a certified lab to measure TKTL1 and DNaseX (Apo10) levels."
  },
  {
    question: "How long does it take to get results?",
    answer:
      "Results are typically available within 5–7 business days after the sample reaches the lab. You’ll receive detailed results along with expert recommendations."
  }
];


  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
   const [showFull, setShowFull] = useState(false);

  const shortText = `RxOne Care Pvt. Ltd. (“RxOne”) is an authorized reseller of the PanTum Detect® cancer screening blood test...`;

  const fullText = `RxOne Care Pvt. Ltd. (“RxOne”) is an authorized reseller of the PanTum Detect® cancer screening blood test, developed and provided by Medidect India Pvt. Ltd. All information related to the PanTum Detect test, including its purpose, clinical usage, limitations, and results, is provided by Medidect India and is subject to their terms and conditions, scientific validations, and regulatory approvals.

RxOne does not manufacture, modify, or interpret the test and is not responsible for the diagnostic outcome or any medical decisions taken based on the test results. The PanTum Detect test is intended as a screening tool and is not a substitute for clinical diagnosis or consultation with a qualified healthcare professional.

Individuals are advised to consult their physician or a certified medical practitioner before and after taking the test for appropriate guidance, interpretation, and follow-up. Use of this test and any reliance on the results is at the user’s sole discretion and risk.

For technical details, performance data, and medical support, please refer to Medidect India Pvt. Ltd. or visit their official website.`;

  return (
    <>
     <Helmet>
  <title>PanTum Detect® Cancer Screening by RxOne</title>
  <meta
    name="description"
    content="RxOne Care Pvt. Ltd. is an authorized reseller of the PanTum Detect® cancer screening blood test by Medidect India Pvt. Ltd. Learn more about its clinical use, limitations, and guidance."
  />
</Helmet>
    <section
  className="phantom-section"
  style={{
    marginTop: isMobile ? 0 : '6rem'
  }}
>
  <div className="phantom-container">
    <div className="phantom-grid">
      
      {/* Left Section */}
    <div className="phantom-left">
  <img src={phantompic} alt="PanTum Logo" className="phantom-logo" />
  <h1>
     India's first ever <span className="highlight">EDIM Technology </span>based blood test 
  </h1>
  <p>
   
PanTum® Detect is a SMART screening blood test that leverages the human immune system to uncover silent pre-malignant and malignant tumor growth in healthy persons, before symptoms appear.
  </p>
  <div className="phantom-buttons">
   <button className="btn-primary2" onClick={handleLearnMoreClick}>
  Learn More
</button>
    {/* <button className="btn-outline">Find a Testing Center</button> */}
  </div>
  <ul className="phantom-features">
    <li><span className="checkmark">✔</span> 50+ Publication</li>
    <li><span className="checkmark">✔</span> 97.5% Sensitivity</li>
    <li><span className="checkmark">✔</span> 2,50,000+ Tests Performed Globally</li>
  </ul>
<div
  style={{
    marginTop: "18px",
    fontWeight: 600,
    color: "#019a9e",
    fontSize: "1.05rem",
    letterSpacing: "0.5px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap"
  }}
  className="phantom-available-row"
>
  <span style={{ display: "inline-block", marginRight: 8 }}>Available in</span>
  <span className="phantom-available-city">
    <MapPin size={16} style={{ color: "#019a9e", marginRight: 4 }} />
    Delhi NCR
  </span>
  <span className="phantom-available-city">
    <MapPin size={16} style={{ color: "#019a9e", marginRight: 4 }} />
    Madhya Pradesh
  </span>
  <span className="phantom-available-city">
    <MapPin size={16} style={{ color: "#019a9e", marginRight: 4 }} />
    Imphal
  </span>
</div>
</div>

      {/* Right Form */}
      <div className="lg:pl-12" ref={formRef}>
  <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
    {/* Decorative Elements */}
    <div className="absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>
    <div className="absolute bottom-0 left-0 w-24 h-24 opacity-5 transform -rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>

    {submitted ? (
      <div className="text-center py-4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(1, 154, 158, 0.1)' }}>
          <CheckCircle className="w-8 h-8" style={{ color: 'rgb(1, 154, 158)' }} />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-1">Thank You!</h3>
        <p className="text-sm text-gray-600">Your message has been sent successfully. We'll get back to you soon.</p>
      </div>
    ) : (
      <>
       <div className="text-center mb-4">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-3 flex items-center justify-center gap-3">
  <span
    style={{
      letterSpacing: "1px",
      textTransform: "uppercase",
      background: "linear-gradient(90deg, #019a9e 0%, #00c6b7 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      display: "inline-block"
    }}
  >
    Book
  </span>
  <img
    src={phantompic}
    alt="PanTum Logo"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      height: "30px",
      marginBottom: "2px"
    }}
  />
</h2>
  <p className="text-sm text-gray-600">
    Fill out the form and we'll contact you within 24 hours
  </p>
</div>

        <div className="space-y-4">
          {/* Name Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <User className="w-4 h-4 mr-2 text-gray-500" />
              Full Name *
            </label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Email Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Mail className="w-4 h-4 mr-2 text-gray-500" />
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Phone Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Phone className="w-4 h-4 mr-2 text-gray-500" />
              Phone Number *
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Address Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <MapPin className="w-4 h-4 mr-2 text-gray-500" />
              Address *
            </label>
            <textarea
              name="address"
              placeholder="Enter your complete address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white resize-none"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>
{/* Coupon Code Field */}
<div>
  <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
    🎟️ Coupon Code (optional)
  </label>
  <input
    type="text"
    name="coupon"
    placeholder="Enter coupon code"
    value={formData.coupon}
    onChange={handleChange}
    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
    style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
  />
</div>

          {/* Submit Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className={`w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-xl'
            }`}
            style={{
              backgroundColor: loading ? '#gray' : 'rgb(1, 154, 158)',
              boxShadow: loading ? 'none' : '0 4px 15px rgba(1, 154, 158, 0.3)',
            }}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Submitting...
              </>
            ) : (
              <>
                <Send className="w-5 h-5 mr-2" />
                Book Now
              </>
            )}
          </button>

          {/* Trust Indicators */}
          {/* <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
              <div className="flex items-center">
                <Shield className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                SSL Secured
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                No Spam
              </div>
              <div className="flex items-center">
                <Star className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                Trusted
              </div>
            </div>
          </div> */}
        </div>
      </>
    )}
  </div>
</div>

        

    </div>
  </div>
</section>
     <section id="about" className="PhantomTest-section" ref={aboutRef}>
  <div className="PhantomTest-container">
    <div className="PhantomTest-text-center PhantomTest-section-header">
      <h2>
        Cancer in <span className="PhantomTest-highlight">India</span>: The Facts
      </h2>
      <p>
        Understanding the scale of cancer in India underscores the importance of early detection.
      </p>
    </div>

    <div className="PhantomTest-facts-grid">
      <div className="PhantomTest-fact-box">
        <div className="PhantomTest-fact-number">
          {factNumbers.oneInTen} in 10
        </div>
        <p>Indians will develop cancer during their lifetime</p>
      </div>
      <div className="PhantomTest-fact-box">
        <div className="PhantomTest-fact-number">
          {factNumbers.ninety}%
        </div>
        <p>Survival rate when detected at Stage 1</p>
      </div>
      <div className="PhantomTest-fact-box">
        <div className="PhantomTest-fact-number">
          {factNumbers.lakh.toLocaleString("en-IN")}
        </div>
        <p>New cancer cases every year in India</p>
      </div>
      <div className="PhantomTest-fact-box">
        <div className="PhantomTest-fact-number">
          {factNumbers.seventyFive}%
        </div>
        <p>Of cancers in India detected at advanced stages</p>
      </div>
    </div>

    <div className="PhantomTest-mission-text">
      <p>
        Don’t wait for onset of symptoms, pre-book your test today.
      </p>
    </div>
  </div>
</section>
    <section id="test" className="BloodTestSection">
      <div className="BloodTestSection-container">
        <div className="BloodTestSection-header">
          <h2>
            Discover Medidect <span className="BloodTestSection-highlight">Revolutionary</span> Blood Test
          </h2>
          <p>
            The test has an IVD CE certified sensitivity of 97.5% and a specificity of 99%. It uses EDIM® (Epitope Detection in Monocytes) technology to detect multi-tumor enzyme biomarkers Apo10 and TKTL1 in immune cells (macrophages) which are detectable in all phases of tumor development.
          </p>
        </div>

      <div ref={videoRef} className="BloodTestSection-videoWrapper">
  <div className="BloodTestSection-aspectRatio">
    {playVideo && (
      <div
        id="pantum-video"
        className="BloodTestSection-iframe"
        style={{ width: "100%", height: "100%" }}
      ></div>
    )}
  </div>
</div>

        <div className="BloodTestSection-cta">
          <p>
            With a simple blood draw, we can detect cancer biomarkers months before conventional tests.
          </p>
         <button className="BloodTestSection-button" onClick={handleScheduleClick}>
  Schedule Your Test Today
</button>
        </div>

        <div className="BloodTestSection-cards">
          <div className="BloodTestSection-card">
            <h3>Simple Procedure</h3>
            <p>
              A quick blood draw is all it takes – no invasive procedures or lengthy hospital visits required.
            </p>
          </div>
          <div className="BloodTestSection-card">
            <h3>Fast Results</h3>
            <p>
              Get your comprehensive results within 48 hours, allowing for rapid medical follow-up if needed.
            </p>
          </div>
          <div className="BloodTestSection-card">
            <h3>Life-Saving Detection</h3>
            <p>
              Early detection dramatically increases survival rates. Don’t wait for symptoms to appear.
            </p>
          </div>
        </div>
      </div>
    </section>
<section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        {/* Section Header */}
        <div className="testimonials-header">
          <h2 className="testimonials-title">
            Lives <span className="highlight">Transformed</span> Through Early Detection
          </h2>
          <p className="testimonials-subtitle">
            Hear from patients and doctors who have experienced the life-changing benefits of medidect early cancer detection technology.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card"
              style={{ animationDelay: `${0.2 * (index + 1)}s` }}
            >
              <div className="testimonial-author">
                <div className="avatar">
                  {testimonial.image ? (
                    <img src={testimonial.image} alt={testimonial.name} />
                  ) : (
                    <span className="avatar-initials">
                      {testimonial.name.split(" ").map((n) => n[0]).join("")}
                    </span>
                  )}
                </div>
                <div className="author-info">
                  <p className="author-name">{testimonial.name}</p>
                  <p className="author-role">{testimonial.role}</p>
                </div>
              </div>

              <div className="testimonial-text">
                <svg className="quote-icon" fill="currentColor" viewBox="0 0 32 32">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                {testimonial.testimonial}
              </div>

              {testimonial.rating && (
                <div className="testimonial-rating">
                  {"⭐".repeat(testimonial.rating)}
                  <span className="stars-empty">
                    {Array(5 - testimonial.rating).fill("☆").join("")}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

      {/* <div className="testimonials-footer">
  <p className="testimonials-footer-text">
    Join the thousands of Indians who have taken control of their health through early detection
  </p>
</div> */}

      </div>
    </section>
    <HospitalTreatmentsShowcase/>
 <section className="py-14 bg-gradient-to-b from-white to-gray-100">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Header */}
    <div className="text-center mb-10">
      <div className="flex items-center justify-center mb-3">
        <HelpCircle className="w-7 h-7 text-teal-500 mr-2" />
        <h2 className="testimonials-title">
          Frequently Asked <span className="text-teal-500">Questions</span>
        </h2>
      </div>
      <p className="testimonials-subtitle">
        Learn more about <strong>PanTum® Detect</strong> and early cancer screening.
      </p>
    </div>

    {/* FAQ Accordion */}
    <div className="space-y-3">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow transition-shadow duration-300"
        >
          <button
            className="w-full flex items-center justify-between px-4 py-4 text-left focus:outline-none focus:ring-2 focus:ring-teal-500"
            onClick={() => toggleAccordion(index)}
          >
            <h3 className="text-base font-medium text-slate-800 pr-3">
              {faq.question}
            </h3>
            {activeIndex === index ? (
              <ChevronUp className="w-5 h-5 text-teal-500" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-400" />
            )}
          </button>
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${
              activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-4 pb-4">
              <div className="h-px bg-gradient-to-r from-teal-100 to-transparent mb-3"></div>
              <p className="text-sm text-gray-700 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Call to Action */}
    <div className="mt-10 text-center">
      <div className="bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-6 border border-teal-100">
        <h3 className="text-lg font-semibold text-slate-800 mb-2">
          Still have questions?
        </h3>
        <p className="text-sm text-gray-600 mb-5">
          Our experts can help you understand early detection with PanTum® Detect.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
         <button
            className="px-5 py-2.5 bg-teal-500 text-white text-sm font-medium rounded-lg hover:bg-teal-600 transition"
            onClick={handleScheduleClick}
          >
            Contact Team
          </button>
          {/* <button className="px-5 py-2.5 bg-white text-teal-600 text-sm font-medium rounded-lg border border-teal-300 hover:bg-teal-50 transition">
            Book Consultation
          </button> */}
        </div>
      </div>
    </div>

    {/* Medical Disclaimer */}
      <div className="mt-6 p-3 bg-blue-50 rounded-md border-l-4 border-blue-400">
      <p className="text-xs text-blue-800 leading-snug whitespace-pre-line">
        <strong>Disclaimer:</strong>{" "}
        {showFull ? fullText : shortText}
      </p>
      <button
        onClick={() => setShowFull(!showFull)}
        className="text-blue-600 text-xs mt-2 underline"
      >
        {showFull ? "Show less" : "Show more"}
      </button>
    </div>
  </div>
</section>



    </>
  );
};

export default PhantomTest;
